
// Cursor style indicating that an element is being grabbed
export const CURSOR_GRABBING = 'grabbing';

// Cursor style for resizing the element horizontally (east)
export const CURSOR_E_RESIZE = 'e-resize';

// Cursor style for resizing the element vertically (south)
export const CURSOR_S_RESIZE = 's-resize';

// Cursor style indicating that an action is not allowed
export const CURSOR_NOT_ALLOWED = 'not-allowed';

// Cursor style indicating a pointer, typically for clickable elements
export const CURSOR_POINTER = 'pointer';

// Cursor style indicating that an element can be grabbed
export const CURSOR_GRAB = 'grab';

// Hover state indicating that the interaction is blocked
export const HOVER_BLOCKED = 'blocked';

// Hover state indicating the border is horizontal
export const HOVER_BORDER_HORIZONTAL = 'border-horizontal';

// Hover state indicating the border is vertical
export const HOVER_BORDER_VERTICAL = 'border-vertical';

// Layer ID for the drag layer
export const DRAG_LAYER = 'dragLayer';

// Layer ID for editing the border of the layer
export const DRAG_LAYER_BORDER = 'editLayerBorder';

// Constant representing the start of a drag action
export const DRAG_START = 'dragStart';

// Layer ID for a generic hover layer
export const HOVER_LAYER = 'layer';
